import React      from 'react';
import CSSModules from 'react-css-modules';
import TrainingTypeIcon from '../TrainingTypeIcon';
import navigator from '../../services/navigator';
import style from './style.scss';

class MarketingInfo extends React.Component {

    _navigateTo(url, e) {
        e.preventDefault();
        navigator.push(url);
    }

    render() {

        return (
            <div className={style['container']}>
                <div>
                    <div className={style['info-panel']}>

                        <a href="" onClick={this._navigateTo.bind(this, '/courses')} className={style['info-panel__header']}>
                            <TrainingTypeIcon type="course"/>
                            <h2 className={style['info-panel__heading']}>Courses</h2>
                        </a>

                        <div className={style['info-panel__text-container']}>
                            <h3 className={style['info-panel__sub-heading']}>New Skills</h3>
                            <p className={style['info-panel__text']}>
                                RHE is long recognised for delivering high-quality, practical courses for professionals working in the environmental health and housing sectors. Classes and workshops are presented by experts in their respective fields, employing a variety of interesting and effective methods to enable delegates to hone skills in a mutually supportive environment.
                            </p>
                        </div>
                    </div>

                    <div className={style['info-panel']}>

                        <a href="" onClick={this._navigateTo.bind(this, '/e-learning')} className={style['info-panel__header']}>
                            <TrainingTypeIcon type="elearning"/>
                            <h2 className={style['info-panel__heading']}>e-Learning</h2>
                        </a>

                        <div className={style['info-panel__text-container']}>
                            <h3 className={style['info-panel__sub-heading']}>Instant Training</h3>
                            <p className={style['info-panel__text']}>
                                In response to the changing needs of our clients, RHE is developing a range of online courses, providing a flexible, cost-effective alternative to face-to-face training. Interactive modules written by subject specialists are delivered within an easy-to-use interface. Watch this space as more courses are added to our portfolio.
                            </p>
                        </div>
                    </div>

                    <div className={style['info-panel']}>

                        <a href="" onClick={this._navigateTo.bind(this, '/conferences')} className={style['info-panel__header']}>
                            <TrainingTypeIcon type="conference"/>
                            <h2 className={style['info-panel__heading']}>Conferences</h2>
                        </a>

                        <div className={style['info-panel__text-container']}>
                            <h3 className={style['info-panel__sub-heading']}>Expanding Networks</h3>
                            <p className={style['info-panel__text']}>
                                RHE regularly organises topical and informative conferences. Presented by panels of carefully selected and respected speakers, these events provide the perfect opportunity for attendees to learn whilst sharing ideas with others working in the same field.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default CSSModules(MarketingInfo, style);


// WEBPACK FOOTER //
// ./components/MarketingInfo/index.js